export default __webpack_public_path__ + "static/media/dandelions-preview.7c986cb3.png";